module.exports = __webpack_public_path__ + "static/media/start-message.90558e5d.svg";